import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class MeditationNoteByIdRequest extends FilterRequest {
	MeditationId: number = 0;
	constructor(obj?: Partial<MeditationNoteByIdRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
